import { createAction, props } from '@ngrx/store';

import {
  UserProfileResponse,
  EmergencyStopResponse,
  UserRolesResponse,
} from '../models/dashboard.model';

export const loadUser = createAction('[User] Load User');

export const loadUserSuccess = createAction(
  '[User] Load User Success',
  props<{ user: UserProfileResponse }>()
);

export const loadUserFailure = createAction(
  '[User] Load User Failure',
  props<{ error: any }>()
);

export const freezeAccount = createAction('[Account] Freeze Account');

export const freezeAccountSuccess = createAction(
  '[Account] Freeze Account Success'
);

export const freezeAccountFailure = createAction(
  '[Account] Freeze Account Failure',
  props<{
    error: {
      message: string;
      userId?: string;
      status?: string;
    };
  }>()
);

export const emergencyStopAccount = createAction(
  '[Account] Emergency Stop Account',
  props<{ reason: string }>()
);

export const emergencyStopAccountSuccess = createAction(
  '[Account] Emergency Stop Account Success',
  props<{ response: EmergencyStopResponse }>()
);

export const emergencyStopAccountFailure = createAction(
  '[Account] Emergency Stop Account Failure',
  props<{
    error: {
      message: string;
      userId?: string;
      status?: string;
    };
  }>()
);

export const killSwitchAccount = createAction(
  '[Account] Kill Switch Account',
  props<{ reason: string; enablePanicMode: boolean }>()
);

export const killSwitchAccountSuccess = createAction(
  '[Account] Kill Switch Account Success'
);

export const killSwitchAccountFailure = createAction(
  '[Account] Kill Switch Account Failure',
  props<{
    error: {
      message: string;
      userId?: string;
      status?: string;
    };
  }>()
);

export const loadRoles = createAction('[Roles] Load Roles');

export const loadRolesSuccess = createAction(
  '[Roles] Load Roles Success',
  props<UserRolesResponse>()
);

export const loadRolesFailure = createAction(
  '[Roles] Load Roles Failure',
  props<{ error: any }>()
);

export const loadOwnUnfreezeRequest = createAction(
  '[User] Load Own Unfreeze Request'
);

export const loadOwnUnfreezeRequestSuccess = createAction(
  '[User] Load Own Unfreeze Request Success',
  props<{ pendingRequestId: string | null }>()
);

export const loadOwnUnfreezeRequestFailure = createAction(
  '[User] Load Own Unfreeze Request Failure',
  props<{ error: any }>()
);

export const requestOwnUnfreeze = createAction('[User] Request Own Unfreeze');

export const requestOwnUnfreezeSuccess = createAction(
  '[User] Request Own Unfreeze Success',
  props<{ requestId: string }>()
);

export const requestOwnUnfreezeFailure = createAction(
  '[User] Request Own Unfreeze Failure',
  props<{ error: any }>()
);
